<template>
  <v-dialog
    v-model="isAlertPartnerLink"
    width="600px"
    persistent>
    <v-card>
      <v-card-title class="text-size-5 pl-5">
        パートナー連携完了
      </v-card-title>
      <v-divider />

      <v-container
        fluid
        class="pt-3">
        <v-row
          justify="center"
          align="center">
          <v-col
            cols="3"
            class="text-right">
            <v-avatar size="60">
              <v-img
                :src="partner.pictureUrl"
                :alt="partner.displayName" />
            </v-avatar>
          </v-col>
          <v-col cols="7">
            <strong class="ml-3 text-truncate">{{ partner.displayName }}</strong>
          </v-col>
        </v-row>

        <v-row
          justify="center"
          class="mr-5">
          <v-icon large>
            mdi-close
          </v-icon>
        </v-row>

        <v-row
          justify="center"
          align="center">
          <v-col
            cols="3"
            class="text-right">
            <v-avatar size="60">
              <v-img
                :src="$store.state.profile.pictureUrl"
                :alt="$store.state.profile.displayName" />
            </v-avatar>
          </v-col>
          <v-col cols="7">
            <strong class="ml-3 text-truncate">{{ $store.state.profile.displayName }}</strong>
          </v-col>
        </v-row>

        <v-card-text class="mt-1">
          <v-row
            no-gutters
            class="caption">
            <ul>
              <li class="mt-1">
                連携した状態で登録した思い出はパートナーと共有されます
              </li>
              <li class="mt-1">
                <strong>"パートナー切り替え"</strong> からそれぞれの思い出に切り替えることができます
              </li>
            </ul>
          </v-row>
        </v-card-text>

        <v-row justify="center">
          <v-card-actions>
            <v-btn
              color="primary"
              text
              @click="confirm();">
              確認
            </v-btn>
          </v-card-actions>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import dataStore from '../../libs/dataStore';
import partnerAccess from '../../libs/partnerAccess';

export default {
  data() {
    return {
      isAlertPartnerLink: false,
      partner: {
        displayName: '',
        pictureUrl: '',
        userId: '',
      },
    };
  },
  watch: {
    '$store.state.profile.alertPartnerLink': function() {
      this.isAlertPartnerLink = this.$store.state.profile.alertPartnerLink;

      if (this.isAlertPartnerLink) {
        this.$store.state.selectUsers.forEach(user => {
          if (this.$store.state.profile.alertPartnerLink === user.lineId) {
            this.partner.displayName = user.displayName;
            this.partner.pictureUrl = user.pictureUrl;
            this.partner.userId = user.userId;
          }
        });
      }
    },
  },
  methods: {
    confirm: async function() {
      this.isAlertPartnerLink = false;
      this.$store.commit('updateAlertPartnerLink', '');
      const result = await dataStore.userAlertPut(this.$store.state.profile.lineId, 'alertPartnerLink', '');

      if (!result) {
        this.$store.dispatch('showSnackbar', {
          ga: this.$ga,
          snackbar: {
            color: 'warning',
            text: 'ネットワーク接続を確認してください',
          },
        });
      }
      else {
        partnerAccess.setCurrentUserId(this.partner.userId);
        this.$store.commit('updateCurrentUserId', this.partner.userId);

        this.$router.push('/trip');

        setTimeout(() => {
          this.$store.commit('reloadMemories');
          this.$store.dispatch('showSnackbar', {
            ga: this.$ga,
            snackbar: {
              color: 'info',
              text: 'パートナーを切り替えています...',
              timeout: 2000,
            },
          });
        }, 200);

      }
    },
  },
};
</script>
